<div [id]="id" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ title }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <ng-container *ngTemplateOutlet="appModalBody"></ng-container>
            </div>

            <div class="modal-footer">
                <ng-container *ngTemplateOutlet="appModalBottom"></ng-container>
            </div>
        </div>
    </div>
</div>
